import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">  
    </span>
    <div class="socials">
      <!-- <a href="#" target="_blank" class="ion ion-social-github"></a> -->
      <a href="https://www.facebook.com/share/15wCXieovV/" target="_blank" class="ion ion-social-facebook"></a>
      <a href="https://www.instagram.com/techfira" target="_blank" class="ion ion-social-instagram"></a>
      <a href="https://www.linkedin.com/company/tech-fira/" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
